import bundleFeature from '../../utils/bundleFeature'
import HandoutsFeatureComponent from './components'
import reducer from './reducer'
import sagas from './sagas'
import actions from './actions'
import selectors from './selectors'

export default bundleFeature({
  Component: HandoutsFeatureComponent,
  actions,
  reducer,
  sagas,
  selectors,
})
